module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@3x-e7398dddade9a9e88f47a1110a4fe719.png";